import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from 'src/apis/HttpBaseApiWrapper';
import { useStudentsService } from 'src/apis/students/useStudentsService';
import { TPaginationParams } from 'src/apis/__shared/shared.interfaces';
import { IStudentSubjectBasedAssessmentListApiResponse } from 'src/apis/students/studentsAssessment.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentSubjectBasedAssessmentListKey =
  'get-student-subject-based -assessment-list';

export const useStudentSubjectBasedAssessmentListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<
    IStudentSubjectBasedAssessmentListApiResponse,
    TQueryError
  >
): UseQueryResult<
  IStudentSubjectBasedAssessmentListApiResponse,
  TQueryError
> => {
  const { getStudentSubjectBasedAssessmentList } = useStudentsService();

  return useQuery<IStudentSubjectBasedAssessmentListApiResponse, TQueryError>({
    queryKey: [getStudentSubjectBasedAssessmentListKey, params],
    queryFn: () => getStudentSubjectBasedAssessmentList(params),
    enabled: true,
    ...options,
  });
};
